export default __webpack_public_path__ + "static/media/IcArrowLeft.55ef6df7.svg";